import React from "react";
import { AttrTypeName } from "src/types/AttrType";
import {
  FormObjectSection,
  FormObjectSectionsStore,
} from "src/components/Forms/FormObjectSection";
import { observer } from "mobx-react-lite";
import { DrawTab } from "./DrawTab";
import { ZSchedSettingsPlan, ZSchedulingSettings } from "../../SchedulingTypes";
import { SchedulingObjType } from "../SchedulingSettingsStore";

interface PropsPlanFields {
  store: FormObjectSectionsStore<SchedulingObjType>;
}

const fieldName = (
  name: keyof ZSchedSettingsPlan,
): ["planSettings", keyof ZSchedSettingsPlan] => ["planSettings", name];

export const PlanFields: React.FC<PropsPlanFields> = observer(({ store }) => (
  <DrawTab>
    <FormObjectSection<ZSchedulingSettings, SchedulingObjType>
      store={store}
      objKey={fieldName("templateObjectId")}
      objType="plan"
      title="Объект: План"
      attrTitle="Выберите атрибуты:"
      attrs={[
        {
          attrKey: fieldName("nameAttributeId"),
          attrLabel: "Название",
          attrType: AttrTypeName.string,
        },
        {
          attrKey: fieldName("groupTaskListAttributeId"),
          attrLabel: "Список групп задач, включенных в план",
          attrType: AttrTypeName.childEntities,
        },
        {
          attrKey: fieldName("startDateAttributeId"),
          attrLabel: "Плановая дата начала",
          attrType: AttrTypeName.date,
        },
      ]}
    />
    <FormObjectSection<ZSchedulingSettings, SchedulingObjType>
      store={store}
      objKey={fieldName("templateObjectId")}
      objType="plan"
      isObjSelect={false}
      attrTitle="Выберите атрибуты принадлежности плана:"
      attrs={[
        {
          attrKey: fieldName("modelLinkAttributeId"),
          attrLabel: "К товарной позиции",
          attrType: AttrTypeName.object,
        },
      ]}
    />
  </DrawTab>
));
